
import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormBurgerToppings = ({
  selectedBurger,
  allTopings,
  burgerToppings,
  handleUpdateToppings,
}) => {
  const toppingsMap = Object.fromEntries(
    burgerToppings.map((t) => [t.topping_id, true])
  );

  const defaultValues = {
    toppings: allTopings.map((topping) => ({
      topping_id: topping.id,
      topping_name: topping.topping_name,
      checked: !!toppingsMap[topping.id],
    })),
  };

  const { register, handleSubmit, control } = useForm({
    defaultValues,
  });

  const { fields } = useFieldArray({
    control,
    name: "toppings",
  });

  const onSubmit = (data) => {
    const toppings = data.toppings.map((t) => ({
      ...t,
      burger_type: selectedBurger.id,
    }));
    handleUpdateToppings(toppings);
  };

  return (
    <div className="container">
      <div className="burger-toppings-container mx-auto">
        <h4 className="text-center fw-bold products-title  mb-4">
          Hamburguesa {selectedBurger.type_description}
        </h4>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th className="text-center">Disponible</th>
                  <th>Topping</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, idx) => (
                  <tr key={field.id}>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        {...register(`toppings.${idx}.checked`)}
                        defaultChecked={field.checked}
                      />
                    </td>
                    <td>{field.topping_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button type="submit" className="btn products-btn w-100 mt-3">
            Guardar
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormBurgerToppings;
